import { Chains, NetworkTypes } from "./enums";

export const CHAIN_INFO = {
  [Chains.POLYGON]: {
    name: "Polygon",
    rpcUrl: "https://polygon-rpc.com",
    scanUrl: "https://polygonscan.com",
  },
  [Chains.POLYGON_AMOY]: {
    name: "Amoy",
    rpcUrl: "https://rpc-amoy.polygon.technology",
    scanUrl: "https://www.oklink.com/amoy",
  },
  [Chains.CHILIZ]: {
    name: "Chiliz",
    rpcUrl: "https://rpc.chiliz.com",
    scanUrl: "https://scan.chiliz.com/",
  },
  [Chains.CHILIZ_SPICY]: {
    name: "Spicy",
    rpcUrl: "https://spicy-rpc.chiliz.com",
    scanUrl: "https://spicy-explorer.chiliz.com/",
  },
  [Chains.AVALANCHE_FUJI]: {
    name: "Fuji",
    rpcUrl: "https://api.avax-test.network/ext/bc/C/rpc",
    scanUrl: "https://testnet.snowscan.xyz/",
  },
  [Chains.AVALANCHE]: {
    name: "Avalanche",
    rpcUrl: "https://api.avax.network/ext/bc/C/rpc",
    scanUrl: "https://snowtrace.io/",
  },
  [Chains.BASE]: {
    name: "Base",
    rpcUrl: "https://mainnet.base.org",
    scanUrl: "https://basescan.org",
  },
  [Chains.BASE_SEPOLIA]: {
    name: "Base Sepolia",
    rpcUrl: "https://sepolia.base.org",
    scanUrl: "https://sepolia.basescan.org",
  },
} as const;

export const getNetworkType = (chainId: string) => {
  switch (chainId) {
    case Chains.POLYGON:
    case Chains.CHILIZ:
    case Chains.AVALANCHE:
    case Chains.BASE:
      return NetworkTypes.MAINNET;
    default:
      return NetworkTypes.TESTNET;
  }
};
